import { Validator } from 'vee-validate'
import i18n from '@/i18n'

Validator.extend('name', {
  getMessage: () => i18n.t('f_v_required_full_name'),
  validate: value => /\S{2,}\s+\S{2,}/.test(value)
})
